import { useRef, useEffect, useState } from 'react';

export const useSecondsRemaining = (
  initialSecondsRemaining: number
): number => {
  const seconds = useRef(initialSecondsRemaining);
  const [remaining, setRemaining] = useState<number>(-1);

  useEffect(() => {
    if (initialSecondsRemaining <= 0) {
      return;
    }

    seconds.current = initialSecondsRemaining;
    setRemaining(seconds.current);

    const interval = setInterval(() => {
      seconds.current = seconds.current - 1;
      setRemaining(seconds.current);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [initialSecondsRemaining, setRemaining]);

  return remaining;
};
